export default "__VITE_ASSET__45d57056__"